
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FeedbackForm from "@/components/FeedbackForm";
import UserFeedbackList from "@/components/UserFeedbackList";

const Feedback = () => {
  const [activeTab, setActiveTab] = useState("submit");
  const [refreshKey, setRefreshKey] = useState(0);

  const handleFeedbackSubmitted = () => {
    // Switch to the "My Feedback" tab and refresh the list
    setActiveTab("history");
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="mb-8 text-center">
          <h1 className="font-poppins font-bold text-3xl text-foreground mb-2">
            Feedback Center
          </h1>
          <p className="font-inter text-muted-foreground">
            Share your thoughts and track your feedback submissions
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="submit" className="font-inter">
              Submit Feedback
            </TabsTrigger>
            <TabsTrigger value="history" className="font-inter">
              My Feedback
            </TabsTrigger>
          </TabsList>

          <TabsContent value="submit">
            <FeedbackForm onFeedbackSubmitted={handleFeedbackSubmitted} />
          </TabsContent>

          <TabsContent value="history">
            <UserFeedbackList key={refreshKey} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Feedback;
